import * as React from 'react';

import type { TypographyProps } from '@coursera/cds-core';
import { Typography } from '@coursera/cds-core';

type Props = { as?: TypographyProps['component'] } & TypographyProps;

/**
 * @deprecated enterprise-ui use Typography2 instead
 */
export const Heading: React.FC<Props> = ({ children, as }) => (
  <Typography color="body" variant="h1semibold" component={as ?? 'h1'}>
    {children}
  </Typography>
);
Heading.displayName = 'Heading';

/**
 * @deprecated enterprise-ui use Typography2 instead
 */
export const LargeText: React.FC<Props> = ({ children, as, ...props }) => (
  <Typography variant="h2" component={as ?? 'div'} {...props}>
    {children}
  </Typography>
);
LargeText.displayName = 'LargeText';

/**
 * @deprecated enterprise-ui use Typography2 instead
 */
export const LabelText: React.FC<Props> = ({ children, as, ...props }) => {
  return (
    <Typography
      variant="h3bold"
      css={{ fontWeight: 600, color: 'var(--cds-color-neutral-primary)', letterSpacing: '-0.1px' }}
      component={as ?? 'div'}
      {...props}
    >
      {children}
    </Typography>
  );
};
LabelText.displayName = 'LabelText';

/**
 * @deprecated enterprise-ui use Typography2 instead
 */
export const ModalHeading: React.FC<Props> = ({ children, as, ...props }) => (
  <Typography variant="h1semibold" component={as ?? 'h1'} {...props}>
    {children}
  </Typography>
);
ModalHeading.displayName = 'ModalHeading';
